import { apiLink } from "./../../../constant/api-link";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { LocalStorageService } from "angular-2-local-storage";
import { Observable } from "rxjs";
import { AuthData, AuthDataV2 } from "../../../model/authentication/auth.data";
import { environment } from "../../../../environments/environment";
import { UserData } from "../../../model/authentication/user.data";

@Injectable({
  providedIn: "root"
})

export class AuthenticationService {

    constructor(
        private http: HttpClient,
        private localStorageService: LocalStorageService
    ) { }

    sub: any;
    public userEmail: string = "";

    login(username: string, password: string): Observable<AuthDataV2> {
        this.userEmail = username;

        const dataObj = {
            ClientId: environment.backOfficeClientId,
            Email: username,
            Password: password,
            GrantType: "password"
        };

        const url = apiLink.authV3;
        const headers = new HttpHeaders({ "Content-Type": "text/json" });

        return this.http.post<AuthDataV2>(url, dataObj, { headers });
    }

    getUserData(username: string): Observable<UserData> {

        const url = apiLink.getUserDataJubili + username;

        return this.http.get<UserData>(url);
    }

    refreshToken(username: string, access_token: string, refresh_token: string): Observable<AuthDataV2> {

        const dataObj = {
            ClientId: environment.backOfficeClientId,
            Access: access_token,
            Refresh: refresh_token,
            Email: username,
            GrantType: "refresh"
        };

        const url = apiLink.authV3;
        const headers = new HttpHeaders({ "Content-Type": "text/json" });

        return this.http.post<AuthDataV2>(url, dataObj, { headers });
    }

    refreshSessionToken(): Observable<AuthDataV2> {

        const user_name = this.localStorageService.get<string>("userEmail");
        const access_token = this.localStorageService.get<string>("accessToken");
        const refresh_token = this.localStorageService.get<string>("refreshToken");

        const dataObj = {
            ClientId: environment.backOfficeClientId,
            Access: access_token,
            Refresh: refresh_token,
            Email: user_name,
            GrantType: "refresh"
        };

        const url = apiLink.authV3;
        const headers = new HttpHeaders({ "Content-Type": "text/json" });

        return this.http.post<AuthDataV2>(url, dataObj, { headers });
    }

    logout(access_token: string): Observable<any> {

        const dataObj = {
          accessToken: access_token
        };

        const url = apiLink.logoutV3;

        const headers = new HttpHeaders({ "Content-Type": "text/json" });

        return this.http.post<any>(url, dataObj, { headers });
    }

    getUserAutocompleteSetting(userSurrkey: number): Observable<boolean> {

        const url = apiLink.getUserAutocompleteJubili;

        const params = new HttpParams().set("userSurrKey", userSurrkey.toString());

        return this.http.get<boolean>(url, { params });

    }

    checkRegister(userEmail: string): Observable<number> {
      const url = apiLink.checkRegister;

      const headers = new HttpHeaders({ "Content-Type": "text/json" });

      const email = `\"${userEmail}\"`;

      return this.http.post<number>(url, email, { headers });
    }
}
